import { render, staticRenderFns } from "./CameraManagement.vue?vue&type=template&id=920d0c32&"
import script from "./CameraManagement.vue?vue&type=script&lang=ts&"
export * from "./CameraManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports